
export const LecsWhiteIcon = () => (
    <img src="/logoWhite.png" alt="My Icon" style={{ width: 24, height: 24 }} />
  );

export const LecsMarineIcon = () => (
    <img src="/logoMarine.png" alt="My Icon" style={{ width: 24, height: 24 }} />
  );
export const MultiLecsDouble = () => (
    <img src="/multiIconDouble.png" alt="My Icon" style={{ width: 60 }} />
  );
export const MultiLecsQuad = () => (
    <img src="/multiIconQuad.png" alt="My Icon" style={{ width: 60 }} />
  );

export const LecsDevice = ({tipo, width = 120}) => (
  <img src={tipo === 'LECS+64' ? '/LecsPlus.png' : tipo === 'LECS-64' ? '/LecsEnterprise.png' : tipo === 'LECS-CORE-4' ? '/Lecs-Core-4P.png' : tipo === 'LECS-CORE-2' ? '/Lecs-Core-2P.png': tipo === 'LECS-CORE-SFP' ? '/Lecs-Core-SFP.png': '/blackLecs.png'} alt="My Icon" style={{ width: width }} />
)
